
import { useParams } from "react-router-dom"; // Added useParams
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// Import your components
import WhatWeDo from "../components/Project/WhatWeDo";
import WorkETF from "../components/Project/WorkETF";
import WorkETF2 from "../components/Project/WorkETF2";
import WorkETF3 from "../components/Project/WorkETF3";
import WorkETF4 from "../components/Project/WorkETF4";
import WorkETF5 from "../components/Project/WorkETF5";
import WorkETFDetails from "../components/Project/WorkETFDetails";
import WorkGallery1 from "../components/Project/WorkGallery1";
import WorkGallery2 from "../components/Project/WorkGallery2";
import WorkGallery3 from "../components/Project/WorkGallery3";
import WorkGallery4 from "../components/Project/WorkGallery4";
import WorkGallery5 from "../components/Project/WorkGallery5";
import WorkWithUs from "../components/Project/WorkWithUs";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// 1. DATA MAPPING: Define the content for each project ID
const projectContent = {
  "1": {
    name: "AutoHaus",
    hero: <WorkETF title="AutoHaus" subtitle="Branding | PR" />, // You can pass props if your components support them
    details: <WorkETFDetails description="Luxury automotive branding." />,
    gallery1: <WorkGallery1 images={["/AutoHaus-1.png"]} />, 
  },
  "2": {
    name: "Creative Corner Summit",
    hero: <WorkETF4 />, // Defaulting to your ETF components
    details: <WorkETFDetails />,
    gallery2: <WorkGallery4 />,
  },
    "3": {
    name: "Crunchies Fried Chicken",
    hero: <WorkETF2 />, // Defaulting to your ETF components
    details: <WorkETFDetails />,
    gallery2: <WorkGallery2 />,
  },
    "4": {
    name: "Bistro",
    hero: <WorkETF3 />, // Defaulting to your ETF components
    details: <WorkETFDetails />,
    gallery2: <WorkGallery3 />,
  },
    "5": {
    name: "Roots Restaurant",
    hero: <WorkETF5 />, // Defaulting to your ETF components
    details: <WorkETFDetails />,
    gallery2: <WorkGallery5 />,
  }
  // Add 3, 4, 5... as needed
};

export default function Project() {
  const { id } = useParams(); // 2. Get the ID from the URL

  // 3. Find the current project data
  const currentProject = projectContent[id] || projectContent["2"]; // Fallback to ETF if ID not found


  return (
    <main className="w-full overflow-x-hidden" style={{ backgroundColor: "#ffffff" }}>

      {/* 4. Render the dynamic components from our mapping */}
      <div>
        {currentProject.hero}
        {currentProject.details}
        {currentProject.gallery1}
        {currentProject.testimonial}
        {currentProject.gallery2}
        <WhatWeDo/>
        <WorkWithUs/>
      </div>

    </main>
  );
}